<style lang="scss" scoped>
@import '@/styles/variables.scss';
.nog {
	position: relative;
	height: 50px;
	width: 50px;
	background: transparent;
	overflow: hidden;
	transition: ease;
	animation: rotate 0.7s infinite;
	animation-timing-function: ease-in-out;
	margin: auto;
}
.b {
	background: $primary;
	border-radius: 50%;
	width: 15px;
	height: 15px;
	position: absolute;
	left: calc(50% - 8.5px);
	top: calc(50% - 8.5px);
	animation-timing-function: ease-in-out;
}
.b1 {
	animation: bounce1 0.7s infinite;
}
.b2 {
	animation: bounce2 0.7s infinite;
}
@keyframes bounce1 {
	0% {
		transform: translate(0, 0);
	}
	50% {
		transform: translate(-7.5px, 0);
	}
	100% {
		transform: translate(0, 0);
	}
}
@keyframes bounce2 {
	0% {
		transform: translate(0, 0);
	}
	50% {
		transform: translate(7.5px, 0);
	}
	100% {
		transform: translate(0, 0);
	}
}
@keyframes rotate {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>

<template>
    <div class='nog'>
        <div class='b b1'></div>
        <div class='b b2'></div>
    </div>
</template>

<script>
export default {}
</script>
